<template>
  <v-container fluid>
    <TableFilter
      :columns="columnFilterHeaders"
      @search="onSearch"
    />

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      item-value="id"
      class="elevation-1"
      @contextmenu.prevent="onRightClick"
      key="table"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn
          small
          icon
          @click="confirmDeleteUser(item)"
        >
          <v-icon
            dark
            color="grey darken-4"
            >mdi-delete</v-icon
          >
        </v-btn>
      </template>
      <template v-slot:item.roles="{ item }">
        <v-select
          :items="rolesList"
          v-model="item.roles"
          item-value="id"
          item-text="name"
          placeholder="Select..."
          dense
          outlined
          hide-details
          :menu-props="{ closeOnContentClick: true }"
          @change="onRoleChange(item)"
          :key="item.id + '-' + item.roles"
          mulitple="false"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import PermissionsAPI from '@/api/PermissionsAPI'
  import Toast from '@/components/common/toasts'
  import { SHOW_DELETE_USER_MODAL, SET_USERS } from '@/appLogic/permissions/store/constants'
  import TableFilter from '../inputs/TableFilter.vue'
  import { cloneDeep } from 'lodash'

  export default {
    components: { TableFilter },
    props: {
      copiedUserList: {
        type: Array,
        default: () => [],
      },
      rolesList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        rowData: [],
        table: 0,
        userToDelete: null,
        contextMenu: {
          visible: false,
          x: 0,
          y: 0,
        },
        headers: [
          {
            text: '',
            value: 'actions',
            sortable: false,
            width: 60,
          },
          {
            text: 'First Name',
            value: 'first_name',
            filterable: true,
          },
          {
            text: 'Last Name',
            value: 'last_name',
            filterable: true,
          },
          {
            text: 'Email',
            value: 'email',
            filterable: true,
            align: 'center',
          },
          {
            text: 'Roles',
            value: 'roles',
            align: 'center',
            sortable: false,
          },
        ],
        searchQuery: {
          column: null,
          mode: 'contains',
          text: '',
        },
      }
    },
    mounted() {},
    computed: {
      columnFilterHeaders() {
        return this.headers.filter(h => h.value !== 'roles')
      },
      filteredItems() {
        const { column, mode = 'starts with', text } = this.searchQuery
        if (!text) return this.rowData
        const searchText = text.toLowerCase()
        const matches = value => {
          if (!value) return false
          value = String(value).toLowerCase()
          switch (mode) {
            case 'starts with':
              return value.startsWith(searchText)
            case 'ends with':
              return value.endsWith(searchText)
            case 'contains':
              return value.includes(searchText)
            case 'not contains':
              return !value.includes(searchText)
            case 'not equals':
              return value !== searchText
            default:
              return value.includes(searchText)
          }
        }
        return this.rowData.filter(item => {
          if (column) {
            return matches(item[column])
          } else {
            return ['first_name', 'last_name', 'email'].some(field => matches(item[field]))
          }
        })
      },
    },
    watch: {
      copiedUserList: {
        immediate: true,
        handler(newList) {
          if (!newList || newList.length === 0) {
            this.rowData = []
            return
          }
          const clonedList = JSON.parse(JSON.stringify(newList))
          this.rowData = clonedList.map(user => {
            if (!user.roles) return { ...user, roles: undefined }
            if (Array.isArray(user.roles)) {
              return { ...user, roles: user.roles.length > 0 ? user.roles[0] : undefined }
            }
            return { ...user, roles: user.roles }
          })
        },
      },
    },
    methods: {
      async onRoleChange(user) {
        const payload = {
          ...user,
          roles: Array.isArray(user.roles) ? user.roles : [user.roles],
        }
        try {
          await PermissionsAPI.upsertUser(payload)
          Toast.success({
            title: `User Role Updated`,
            message: `Role for ${payload.first_name} ${payload.last_name} has been updated`,
          })
          await this.$store.dispatch(SET_USERS)
          this.rowData = cloneDeep(this.copiedUserList).map(user => ({
            ...user,
            roles: user.roles
              ? typeof user.roles === 'number'
                ? user.roles
                : Array.isArray(user.roles) && user.roles.length > 0
                  ? user.roles[0]
                  : undefined
              : undefined,
          }))
          this.filteredItems = cloneDeep(this.rowData)
        } catch (error) {
          console.error('Failed to update user role', error)
          Toast.error({
            title: 'Update User Error',
            message: 'Update User has an error, please refresh and try again',
          })
        }
      },
      confirmDeleteUser(user) {
        this.$parent.setUserToDelete(user)
        this.$store.dispatch(SHOW_DELETE_USER_MODAL)
      },
      getDataPath(data) {
        return data.categoryTree
      },
      onGridReady(params) {
        params.api.sizeColumnsToFit()
      },
      getRoles(params) {
        if (params) {
          const roleIds = params.data.roles
          if (!roleIds) {
            return ''
          } else {
            const roleNamesArray = roleIds.map(roleId => {
              const rn = this.rolesList.filter(el => el.id === roleId)[0]
              return rn && rn.name ? '\xa0' + rn.name : ''
            })
            return roleNamesArray || ''
          }
        }
      },
      getContextMenuItems(params) {
        return [
          'copy',
          'copyWithHeaders',
          'separator',
          {
            name: 'Clear All Filters',
            action: () => {
              this.$router.push({})
              params.api.setFilterModel(null)
            },
          },
        ]
      },
      onSearch(query) {
        this.searchQuery = query
      },
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// UserList.vue?577acdc6